import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GalleryProvider } from "@/contexts/GalleryContext";
import Index from "./pages/Index";
import { ScrollToTop } from "./components/ScrollToTop";
import { useImagePreloader } from "./hooks/useImagePreloader";

const NotFound = lazy(() => import("./pages/NotFound"));
const CategoryDetail = lazy(() => import("./pages/CategoryDetail"));
const InspirationDetail = lazy(() => import("./pages/InspirationDetail"));
const About = lazy(() => import("./pages/About"));
const Imprint = lazy(() => import("./pages/Imprint"));
const Gallery = lazy(() => import("./pages/Gallery"));

const queryClient = new QueryClient();

const AppInner = () => {
  // Preload images in background for caching — does NOT block rendering
  useImagePreloader();

  return (
    <>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><About /></Suspense>} />
          <Route path="/imprint" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><Imprint /></Suspense>} />
          <Route path="/gallery" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><Gallery /></Suspense>} />
          <Route path="/category/:slug" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><CategoryDetail /></Suspense>} />
          <Route path="/inspirations/:slug" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><InspirationDetail /></Suspense>} />
          <Route path="*" element={<Suspense fallback={<div className="min-h-screen bg-background" />}><NotFound /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <GalleryProvider>
        <AppInner />
      </GalleryProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
